import { put, select } from 'redux-saga/effects';
import _ from 'lodash';
import * as actions from '../../actions';
import * as events from '../../events';
import * as selectors from '../../selectors';
import getAspectRatio from '../../utils/getAspectRatio';
import getBestMediaResolution from '../../services/getBestMediaResolution';
import { stopStream, getMediaDevices, getFilteredVideo } from '../../utils/devices';
import bugsnagClient from '../../bugsnag';

// import bugsnagClient from '../../bugsnag';

// eslint-disable-next-line import/prefer-default-export
export function* cycleVideoDevices({ payload }) {
  try {
    const {
      // hasCamDevice,
      // hasCamPermissions,
      videoDevice,
      videoStreamSelect,
      // videoMuted,
      userId,
    } = yield select(selectors.selectUserMediaStatus);

    // const meeting = select(selectors.selectMeeting);
    // const myAttendee = select(selectors.selectMyAttendee);
    //
    // const isVideoMuted = () => videoMuted
    //     || !hasCamDevice
    //     || !hasCamPermissions;

    // const notifyRestriction = () => {
    //   if (!hasCamPermissions) {
    //     const title = <FormattedMessage {...messages.CAM_BLOCKED_BY_BROWSER} />;
    //     const content = <FormattedMessage {...messages.CAMERA_DISABLED_TOOLTIP} />;
    //     openAlertDialog({ title, content });
    //   } else {
    //     const title = <FormattedMessage {...messages.CAM_DISABLED_BY_HOST} />;
    //     const content = <FormattedMessage {...messages.CAM_DISABLED_ALERT_CONTENT} />;
    //     openAlertDialog({ title, content });
    //   }
    // };

    // let isVideoPermitted = true;
    // switch (meeting.video_share) {
    //   case 'host':
    //     isVideoPermitted = myAttendee && myAttendee.role === 'host';
    //     break;
    //   case 'presenters':
    //     isVideoPermitted = myAttendee && ['host', 'presenter'].includes(myAttendee.role);
    //     break;
    //   default:
    //     break;
    // }
    //
    // const isVideoRestricted = !myAttendee
    //   || !isVideoPermitted
    //   || Boolean(myAttendee.video_restricted)
    //   || !hasCamPermissions;

    // if (!isVideoMuted) {
    //   if (!isVideoRestricted) {
    const devices = yield getMediaDevices();
    const filteredVideoDevices = getFilteredVideo(devices);
    const currIndx = _.findIndex(filteredVideoDevices, { deviceId: videoDevice.deviceId });
    const videoDeviceSelect = filteredVideoDevices[(currIndx + 1) % filteredVideoDevices.length];
    if (videoDeviceSelect) {
      if (videoStreamSelect) {
        stopStream(videoStreamSelect);
        yield put(actions.updateMediaStatus({
          userId,
          videoStreamSelect: null,
        }));
      }

      const stream = yield getBestMediaResolution(_.get(videoDeviceSelect, 'deviceId'));
      yield put(actions.updateMediaStatus({
        userId,
        videoDeviceSelect,
        videoStreamSelect: stream,
        videoAspectRatioSelect: getAspectRatio(stream),
      }));

      yield put(events.saveSelectedDevices());
    }
    //   } else {
    //     console.error('video is restricted');
    //   }
    // }
  } catch (err) {
    console.error(err);
    bugsnagClient.notify(err, (event) => {
      // eslint-disable-next-line no-param-reassign
      event.context = 'saga: cycleVideoDevices';
      event.addMetadata('payload', payload);
    });
  }
}
